import consumer from "./consumer";

let processTemplateSubscription = null;
const pendingStepInserts = new Set();
const recentlyInsertedSteps = new Set();

document.addEventListener("turbolinks:before-cache", () => {
  if (processTemplateSubscription) {
    consumer.subscriptions.remove(processTemplateSubscription);
    processTemplateSubscription = null;
  }
  pendingStepInserts.clear();
  recentlyInsertedSteps.clear();
});

document.addEventListener("turbolinks:load", () => {
  if (processTemplateSubscription) {
    consumer.subscriptions.remove(processTemplateSubscription);
    processTemplateSubscription = null;
  }
  pendingStepInserts.clear();
  recentlyInsertedSteps.clear();

  const processTemplateContainer = document.querySelector('[data-process-template-id]');
  if (!processTemplateContainer) return;

  const processTemplateId = processTemplateContainer.dataset.processTemplateId;
  const accountId = processTemplateContainer.dataset.accountId;

  if (!processTemplateId || !accountId) {
    return;
  }

  processTemplateSubscription = consumer.subscriptions.create(
    { 
      channel: "ProcessTemplateUpdatesChannel", 
      process_template_id: processTemplateId,
      account_id: accountId
    },
    {
      connected() {
      },

      disconnected() {
      },

      received(data) {
        switch (data.type) {
          case 'step_block_created':
            this.handleStepBlockCreated(data);
            break;
          case 'step_block_update':
            this.handleStepBlockUpdate(data);
            break;
          case 'step_template_created':
            this.handleStepTemplateCreated(data);
            break;
        }
      },

      handleStepBlockCreated(data) {
        if (!data.step_template_id) {
          return;
        }
        
        this.reloadStepTemplateContent(data.step_template_id).then(() => {
          if (data.has_draft_blocks) {
            this.updateStepTemplateColor(data.step_template_id);
          } else {
            this.removeStepTemplateColor(data.step_template_id);
          }
        }).catch(() => {
          setTimeout(() => {
            if (data.has_draft_blocks) {
              this.updateStepTemplateColor(data.step_template_id);
            } else {
              this.removeStepTemplateColor(data.step_template_id);
            }
          }, 1000);
        });
      },

      updateStepTemplateColor(stepTemplateId) {
        const stepTemplateElement = document.querySelector(`div#step_template_${stepTemplateId}.step`);
        
        if (!stepTemplateElement) {
          return;
        }
        
        const inlineStyle = stepTemplateElement.getAttribute('style') || '';
        if (inlineStyle.includes('background-color') && inlineStyle.includes('#88BDF2')) {
          return;
        }
        
        const accountId = document.querySelector('[data-account-id]')?.dataset.accountId;
        let editedStepColor = '#BDDDFC';
        
        if (accountId) {
          const editedStepColorInput = document.getElementById('edited_step_color');
          if (editedStepColorInput && editedStepColorInput.value) {
            editedStepColor = editedStepColorInput.value;
          }
        }
        
        const currentBgColor = window.getComputedStyle(stepTemplateElement).backgroundColor;
        if (currentBgColor === 'rgba(0, 0, 0, 0)' || currentBgColor === 'transparent' || 
            !currentBgColor.includes('136, 189, 242')) {
          stepTemplateElement.style.transition = 'background-color 0.3s ease';
          stepTemplateElement.style.backgroundColor = editedStepColor;
        }
      },

      removeStepTemplateColor(stepTemplateId) {
        const stepTemplateElement = document.querySelector(`div#step_template_${stepTemplateId}.step`);
        
        if (!stepTemplateElement) {
          return;
        }
        
        const inlineStyle = stepTemplateElement.getAttribute('style') || '';
        if (inlineStyle.includes('background-color') && inlineStyle.includes('#88BDF2')) {
          return;
        }
        
        stepTemplateElement.style.backgroundColor = '';
        const currentStyle = stepTemplateElement.getAttribute('style');
        if (!currentStyle || currentStyle.trim() === '' || currentStyle.trim() === 'background-color: ;' || currentStyle.trim() === 'background-color:;') {
          stepTemplateElement.removeAttribute('style');
        }
      },

      handleStepBlockUpdate(data) {
       
        const stepTemplateElement = document.querySelector(`#step_template_${data.step_template_id}`);
        if (stepTemplateElement) {
          this.reloadStepTemplateContent(data.step_template_id);
        }
      },

      handleStepTemplateCreated(data) {
        if (!data.step_template_id) {
          return;
        }
        
        const stepId = data.step_template_id.toString();
        
        if (pendingStepInserts.has(stepId)) {
          return;
        }
        
        if (recentlyInsertedSteps.has(stepId)) {
          return;
        }
        
        const checkForExistingStep = () => {
          const existingStepTemplate = document.querySelector(`li#step_template_${stepId}`);
          if (existingStepTemplate) {
            return true;
          }
          
          const existingByDataAttr = document.querySelector(`li[data-step-id="${stepId}"]`);
          if (existingByDataAttr) {
            return true;
          }
          
          const existingDiv = document.querySelector(`div#step_template_${stepId}`);
          if (existingDiv) {
            const parentLi = existingDiv.closest('li');
            if (parentLi && (parentLi.id.includes(stepId) || parentLi.querySelector(`[data-step-id="${stepId}"]`))) {
              return true;
            }
          }
          
          return false;
        };
        
        if (checkForExistingStep()) {
          recentlyInsertedSteps.add(stepId);
          setTimeout(() => recentlyInsertedSteps.delete(stepId), 2000);
          return;
        }
        
        setTimeout(() => {
          if (checkForExistingStep()) {
            recentlyInsertedSteps.add(stepId);
            setTimeout(() => recentlyInsertedSteps.delete(stepId), 2000);
            return;
          }
          
          pendingStepInserts.add(stepId);
          
          this.fetchAndInsertStepTemplate(data).finally(() => {
            setTimeout(() => {
              pendingStepInserts.delete(stepId);
              recentlyInsertedSteps.add(stepId);
              setTimeout(() => recentlyInsertedSteps.delete(stepId), 2000);
            }, 500);
          });
        }, 100);
      },

      fetchAndInsertStepTemplate(data) {
        const accountId = document.querySelector('[data-account-id]')?.dataset.accountId;
        const processTemplateId = document.querySelector('[data-process-template-id]')?.dataset.processTemplateId;
        
        if (!accountId || !processTemplateId) {
          return Promise.resolve();
        }

        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        const stepId = data.step_template_id.toString();
        const stepTemplateUrl = `/${accountId}/process_templates/${processTemplateId}/render_step_template?step_template_id=${data.step_template_id}`;
        
        return new Promise((resolve, reject) => {
          const existingStepTemplate = document.querySelector(`li#step_template_${stepId}`) || 
                                       document.querySelector(`li[data-step-id="${stepId}"]`);
          if (existingStepTemplate) {
            resolve();
            return;
          }
          
          Rails.ajax({
            url: stepTemplateUrl,
            type: 'GET',
            dataType: 'json',
            success: (response) => {
              const finalCheck = document.querySelector(`li#step_template_${stepId}`) || 
                                document.querySelector(`li[data-step-id="${stepId}"]`);
              if (finalCheck) {
                resolve();
                return;
              }
              
              if (!response.html) {
                resolve();
                return;
              }
              
              const parser = new DOMParser();
              const doc = parser.parseFromString(response.html, 'text/html');
              
              let stepTemplateLi = doc.querySelector(`li#step_template_${data.step_template_id}`);
              if (!stepTemplateLi) {
                const liWithStep = doc.querySelector(`li[id*="step_template_${data.step_template_id}"]`);
                if (liWithStep) {
                  stepTemplateLi = liWithStep;
                } else {
                  const stepDiv = doc.querySelector(`div#step_template_${data.step_template_id}`);
                  if (stepDiv) {
                    stepTemplateLi = document.createElement('li');
                    stepTemplateLi.id = `step_template_${data.step_template_id}`;
                    stepTemplateLi.appendChild(stepDiv.cloneNode(true));
                  }
                }
              }
              
              if (!stepTemplateLi) {
                resolve();
                return;
              }
              
              const stepsContainer = document.querySelector('ol.steps');
              if (!stepsContainer) {
                resolve();
                return;
              }
              
              const preInsertCheck = document.querySelector(`li#step_template_${stepId}`) || 
                                    document.querySelector(`li[data-step-id="${stepId}"]`);
              if (preInsertCheck) {
                resolve();
                return;
              }
              
              const processEnd = stepsContainer.querySelector('.process-end');
              const sentinel = stepsContainer.querySelector('[data-target="process-template-infinite-scroll.sentinel"]');
              const insertPoint = processEnd || sentinel;
              
              const newStepLi = stepTemplateLi.cloneNode(true);
              
              if (insertPoint) {
                stepsContainer.insertBefore(newStepLi, insertPoint);
              } else {
                stepsContainer.appendChild(newStepLi);
              }
              
              if (window.Stimulus) {
                window.Stimulus.load(newStepLi);
                const nestedControllers = newStepLi.querySelectorAll('[data-controller]');
                nestedControllers.forEach(element => {
                  window.Stimulus.load(element);
                });
              }
              
              newStepLi.style.transition = 'background-color 0.3s ease';
              newStepLi.style.backgroundColor = '#e8f5e9';
              setTimeout(() => {
                newStepLi.style.backgroundColor = '';
              }, 2000);
              
              window.scrollTo(0, scrollPosition);
              resolve();
            },
            error: (xhr, status, error) => {
              resolve();
            }
          });
        });
      },

      reloadStepTemplateContent(stepTemplateId) {
        return new Promise((resolve) => {
          let stepTemplateElement = document.querySelector(`#step_template_${stepTemplateId}`);
          if (!stepTemplateElement) {
            const liElement = document.querySelector(`li#step_template_${stepTemplateId}`);
            if (liElement) {
              stepTemplateElement = liElement.querySelector(`div#step_template_${stepTemplateId}`);
            }
          }
          if (!stepTemplateElement) {
            resolve();
            return;
          }

          const tabPanel = stepTemplateElement.querySelector('.tab-panel-content');
          if (!tabPanel) {
            resolve();
            return;
          }

          const accountId = document.querySelector('[data-account-id]')?.dataset.accountId;
          const processTemplateId = document.querySelector('[data-process-template-id]')?.dataset.processTemplateId;
          
          if (!accountId || !processTemplateId) {
            resolve();
            return;
          }

          const isExpanded = stepTemplateElement.classList.contains('expanded');
          
          if (!isExpanded) {
            const stepNav = stepTemplateElement.querySelector('.step-nav');
            if (stepNav) {
              const existingIndicator = stepNav.querySelector('.new-block-indicator');
              if (existingIndicator) {
                existingIndicator.remove();
              }
              
              const indicator = document.createElement('span');
              indicator.className = 'new-block-indicator';
              indicator.textContent = '●';
              indicator.style.cssText = 'color: #4caf50; font-size: 12px; margin-left: 5px; animation: pulse 2s infinite;';
              stepNav.appendChild(indicator);
              setTimeout(() => indicator.remove(), 5000);
            }
          }

          const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
          
          const form = tabPanel.querySelector('form.step-content-form');
          if (!form) {
            resolve();
            return;
          }

          const stepTemplateUrl = `/${accountId}/process_templates/${processTemplateId}/step_templates/${stepTemplateId}`;
          
          Rails.ajax({
            url: stepTemplateUrl,
            type: 'GET',
            dataType: 'html',
            headers: {
              'Accept': 'text/html',
              'X-Requested-With': 'XMLHttpRequest'
            },
            success: (html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              const newStepTemplateElement = doc.querySelector(`#step_template_${stepTemplateId}`);
              if (!newStepTemplateElement) {
                this.fetchStepTemplateFromProcessPage(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition)
                  .then(resolve)
                  .catch(() => resolve());
                return;
              }
              
              const newTabPanel = newStepTemplateElement.querySelector('.tab-panel-content');
              if (!newTabPanel) {
                resolve();
                return;
              }
              
              const newBlocksContainer = newTabPanel.querySelector('.blocks');
              if (!newBlocksContainer) {
                resolve();
                return;
              }

              this.updateBlocksContainer(tabPanel, newBlocksContainer, stepTemplateElement, scrollPosition);
              resolve();
            },
            error: (xhr, status, error) => {
              this.fetchStepTemplateFromProcessPage(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition)
                .then(resolve)
                .catch(() => resolve());
            }
          });
        });
      },

      fetchStepTemplateFromProcessPage(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition) {
        return new Promise((resolve) => {
          const processTemplateUrl = `/${accountId}/process_templates/${processTemplateId}`;
          
          Rails.ajax({
            url: processTemplateUrl,
            type: 'GET',
            dataType: 'html',
            success: (html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              const newStepTemplateElement = doc.querySelector(`#step_template_${stepTemplateId}`);
              if (newStepTemplateElement) {
                const newTabPanel = newStepTemplateElement.querySelector('.tab-panel-content');
                if (newTabPanel) {
                  const newBlocksContainer = newTabPanel.querySelector('.blocks');
                  if (newBlocksContainer) {
                    this.updateBlocksContainer(tabPanel, newBlocksContainer, stepTemplateElement, scrollPosition);
                    resolve();
                    return;
                  }
                }
              }
              
              this.fetchStepTemplateWithOffset(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition)
                .then(resolve)
                .catch(() => resolve());
            },
            error: (xhr, status, error) => {
              this.fetchStepTemplateWithOffset(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition)
                .then(resolve)
                .catch(() => resolve());
            }
          });
        });
      },

      updateBlocksContainer(tabPanel, newBlocksContainer, stepTemplateElement, scrollPosition) {
        const oldBlocksContainer = tabPanel.querySelector('.blocks');
        if (!oldBlocksContainer) {
          return;
        }

        const wasExpanded = stepTemplateElement.classList.contains('expanded');
        
        oldBlocksContainer.replaceWith(newBlocksContainer.cloneNode(true));
        
        const updatedBlocksContainer = tabPanel.querySelector('.blocks');
        
        if (!updatedBlocksContainer) {
          return;
        }
        
        if (window.Stimulus && updatedBlocksContainer) {
          const blocks = updatedBlocksContainer.querySelectorAll('[data-controller]');
          blocks.forEach(block => {
            window.Stimulus.load(block);
          });
          window.Stimulus.load(updatedBlocksContainer);
        }
        
        if (wasExpanded) {
          stepTemplateElement.classList.add('expanded');
        }
        
        const allBlocks = updatedBlocksContainer.querySelectorAll('[data-block-id]');
        if (allBlocks.length > 0) {
          const newBlock = allBlocks[allBlocks.length - 1];
          if (newBlock) {
            newBlock.style.transition = 'background-color 0.3s ease';
            newBlock.style.backgroundColor = '#e8f5e9';
            setTimeout(() => {
              newBlock.style.backgroundColor = '';
            }, 2000);
          }
        }
        
        window.scrollTo(0, scrollPosition);
      },

      fetchStepTemplateWithOffset(stepTemplateId, accountId, processTemplateId, tabPanel, stepTemplateElement, scrollPosition) {
        return new Promise((resolve) => {
          const allStepTemplates = document.querySelectorAll('ol.steps > li[id^="step_template_"]');
          let stepIndex = -1;
          for (let i = 0; i < allStepTemplates.length; i++) {
            if (allStepTemplates[i].id === `step_template_${stepTemplateId}`) {
              stepIndex = i;
              break;
            }
          }
          
          const offset = stepIndex >= 0 ? Math.floor(stepIndex / 10) * 10 : 0;
          
          const url = `/${accountId}/process_templates/${processTemplateId}/load_more_step_templates?offset=${offset}`;
          
          fetch(url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
          .then(response => response.json())
          .then(data => {
            if (data.html) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(data.html, 'text/html');
              const newStepTemplateElement = doc.querySelector(`#step_template_${stepTemplateId}`);
              
              if (newStepTemplateElement) {
                const newTabPanel = newStepTemplateElement.querySelector('.tab-panel-content');
                if (newTabPanel) {
                  const newBlocksContainer = newTabPanel.querySelector('.blocks');
                  if (newBlocksContainer) {
                    this.updateBlocksContainer(tabPanel, newBlocksContainer, stepTemplateElement, scrollPosition);
                    resolve();
                    return;
                  }
                }
              }
            }
            resolve();
          })
          .catch(() => {
            resolve();
          });
        });
      }
    }
  );
});

